import { runAuthGateway } from '@src/js/gateway/auth-gateway';
import config from '@src/js/config';
import Alpine from 'alpinejs';
import '@src/templates-js/partials/header';
import '@src/templates-js/pages/assistants';
import '@src/templates-js/pages/auth';
import '@src/templates-js/pages/confirm-signup';
import '@src/templates-js/pages/assistants/assistant-detail';
import '@src/templates-js/pages/assistants/runner';
import '@src/templates-js/pages/assistants/assistant-transcripts';
import '@src/templates-js/pages/assistants/assistant-transcript';
import '@src/templates-js/pages/admin/feature-flags';
import '@src/templates-js/pages/admin/organisations';
import '@src/templates-js/pages/admin/organisation-detail';
console.log('Running auth gateway...');
runAuthGateway();
console.log('Accessing Alpine store');
Alpine.store('config', config);
console.log("Starting Alpine");
Alpine.start();
console.log("Alpine started");
